import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {Platform, ScrollView, Text, TouchableOpacity, View} from 'react-native';
import FastImage from '../../Utils/FastImage';

//////// utils
import {selectCharacter} from 'src/Utils/huntFunctions';

//////// components
import {BodyText, ContinueButton} from 'src/Modules/CommonView';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {cloudFlareOptimizeImage} from '../../Utils/helpers';
import CustomActivityIndicator from '../../Modules/CommonView/CustomActivityIndicator';

const blankCharacter = {
  character: 'Select A Character',
  description: `Select one of the characters below to learn more about them. 
  Each character has their own style and will help you play and experience the scavenger hunt your way!`,
  source: '',
};

const CharacterSelection = () => {
  const userId = useSelector((state) => state.user?.userId);

  const groupInfo = useSelector((state) => state.groupInfo);
  const {players = {}} = groupInfo;

  const themeInfo = useSelector((state) => state.themeInfo);

  const [selectedCharacter, setSelectedCharacter] = useState(null);

  const playersOnDevice = Object.values(players).filter((player) => {
    return player.userId == userId || player.parentUserId == userId;
  });

  // const playersWithoutCharacters = playersOnDevice?.filter((player) => {
  //   return !player?.character;
  // });

  const handleChooseCharacter = (selectedCharacter) => {
    setSelectedCharacter(selectedCharacter);
  };

  const handleCharacterSelected = async (player) => {
    console.log('handleCharacterSelected fired');

    const {character, question_type} = selectedCharacter;

    await selectCharacter({
      character,
      question_type,
      theme: groupInfo?.theme,
      playerId: player.userId,
      parentUserId: userId,
      groupId: groupInfo?.groupId,
      OS: Platform.OS,
    });
    setSelectedCharacter(null);

    if (playersOnDevice.every((devicePlayer) => devicePlayer.character)) {
      console.log('Character Selection: navigate to main game stack called');
      return navigationRef.navigate('MainGameStack');
    }
  };

  const {groupId} = groupInfo;

  const {themes, characters} = themeInfo;

  console.log({playersOnDevice});

  const currentPlayer =
    (playersOnDevice &&
      playersOnDevice?.length > 0 &&
      playersOnDevice?.find?.((devPlayer) => !devPlayer.character)) ||
    false;

  console.log({playersOnDevice, groupId, currentPlayer});

  const isCharacterSelection = useSelector(
    (state) =>
      state.current_screen?.currentScreen == 'ScavengerHuntCharacterSelection',
  );

  if (!groupId || !currentPlayer) {
    console.log('showing Loading Your Hunt because', {
      groupId,
      groupInfo,
      currentPlayer,
      playersOnDevice,
      userId,
    });
    if (playersOnDevice && isCharacterSelection) {
      console.log('navigating to main game stack');
      // return <View></View>;
      navigationRef.navigate('MainGameStack');
    }
    return (
      <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
        <BodyText
          text={'Loading Your Hunt!!'}
          textStyle={{textAlign: 'center', marginBottom: 0}}
        />
        <BodyText
          text={`Join Code: ${groupId}`}
          textStyle={{textAlign: 'center', marginBottom: 10}}
        />
        <CustomActivityIndicator />
        <ContinueButton
          text={'Reload'}
          containerStyle={{width: 150, marginTop: 100}}
          handlePress={() => {
            navigationRef.navigate('MainGameStack');
          }}
        />
      </View>
    );
  }

  const selectedChar = selectedCharacter || blankCharacter;
  const {source, description, character} = selectedChar;

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: global?.color?.white,
      }}>
      <ScrollView style={{flex: 1}}>
        <View
          testID="chooseYourCharacter"
          style={{
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <Text
            style={{
              color: global?.color?.gray3,
              fontFamily: global?.font.circular,
              fontSize: 18,
              marginVertical: 15,
              textAlign: 'center',
            }}>
            {`${currentPlayer.firstName}! Choose Your Character`}
          </Text>
          <View>
            <FastImage
              source={
                !!source
                  ? {uri: cloudFlareOptimizeImage(source, 200)}
                  : require('src/Images/emptyPlatform.png')
              }
              style={{
                width: 100,
                height: 100,
              }}
              resizeMode={FastImage?.resizeMode?.cover}
            />
          </View>
          <Text
            style={{
              color: global?.color?.gray3,
              fontFamily: global?.font.circular,
              fontSize: 20,
              marginVertical: 5,
              textAlign: 'center',
              fontWeight: '700',
            }}>
            {character}
          </Text>
          <View style={{minHeight: 70}}>
            <Text
              style={{
                color: global?.color?.gray3,
                fontFamily: global?.font.circular,
                fontSize: 12,
                marginHorizontal: 30,
                marginVertical: 10,
                textAlign: 'center',
              }}>
              {description}
            </Text>
          </View>
          <View style={{height: 70}}>
            {!!selectedCharacter && (
              <ContinueButton
                background={global?.color?.orange}
                text={'Confirm'}
                handlePress={() => {
                  handleCharacterSelected(currentPlayer);
                }}
                menu
              />
            )}
          </View>
        </View>
        <View
          style={{
            justifyContent: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginHorizontal: 15,
            alignItems: 'center',
          }}>
          {!!groupInfo?.theme &&
            Object.values(themes[groupInfo?.theme].characters)?.map?.((key) => {
              const character = characters[key] || {};
              return (
                <Character
                  key={character.character}
                  characterObj={character}
                  chooseCharacter={() => {
                    handleChooseCharacter(character);
                  }}
                />
              );
            })}
          <Character
            characterObj={{
              character: 'Random',
              source: require('src/Images/random.png'),
            }}
            chooseCharacter={() => {
              const themeCharacters =
                Object.values(themes[groupInfo?.theme].characters) || [];
              const possibleChars = themeCharacters.filter((key) => {
                const character = characters[key];
                return !(
                  character == selectedCharacter ||
                  character.question_type == 'special' ||
                  character.question_type == 'kid' ||
                  character.question_type == 'none'
                );
              });

              const randomIdx = Math?.floor(
                Math?.random() * possibleChars?.length,
              );

              setSelectedCharacter(characters[possibleChars[randomIdx]]);
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
};

const Character = ({chooseCharacter, characterObj}) => {
  const {source, character} = characterObj;

  return (
    <TouchableOpacity
      onPress={() => {
        chooseCharacter(characterObj);
      }}>
      <View
        style={{
          width: 80,
          height: 100,
          margin: 10,
          justifyContent: 'flex-start',
        }}>
        {!!source && (
          <FastImage
            style={{
              height: 80,
              width: 80,
            }}
            source={
              character === 'Random'
                ? require('src/Images/random.png')
                : {uri: cloudFlareOptimizeImage(source)}
            }
            resizeMode={FastImage?.resizeMode?.cover}
          />
        )}
        <Text
          style={{
            color: global?.color?.gray3,
            fontFamily: global?.font.circular,
            fontSize: 12,
            marginVertical: 5,
            textAlign: 'center',
          }}>
          {character}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default CharacterSelection;
